import Recat, { useEffect, useState } from "react";
import { Loading } from "../components/others/Loading";
import { PageTitle } from "../../_jutemplate/layout/core";
import { useFetchData } from "../../hooks/useFetchData";

// api
import { SeasonAPI } from "../../api/season/seasonAPI";
import { CropAPI } from "../../api/crop/cropAPI";
import { ExperimentAPI } from "../../api/experiment/experimentAPI";

const seasonApi = new SeasonAPI();
const cropApi = new CropAPI();
const experimentApi = new ExperimentAPI();

export const DashBoard: Recat.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);

  // Data fetch custom hook
  const [cropData, cropDataLoading] = useFetchData(() => cropApi.cropList());

  const [seasonData, seasonDataLoading] = useFetchData(() =>
    seasonApi.seasonList()
  );

  const [experimentData, experimentDataLoading] = useFetchData(() =>
    experimentApi.experimentList()
  );

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  });

  return (
    <>
      <PageTitle>DashBoard</PageTitle>
      {loading ? (
        <Loading />
      ) : (
        // <div className="text-center mt-20">
        //       <h3 className="fw-bolder fs-2">Welcome To Bina Notebook</h3>
        // </div>
        <div className="row g-md-4">
          <div className="col-md-6 col-lg-4">
            <div className="bg-primary rounded-2 d-flex gap-3 align-items-center p-5">
              <svg
                width="70"
                height="71"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.0003 17.2399C14.291 17.2399 16.9587 14.5723 16.9587 11.2816C16.9587 7.99088 14.291 5.32324 11.0003 5.32324C7.70963 5.32324 5.04199 7.99088 5.04199 11.2816C5.04199 14.5723 7.70963 17.2399 11.0003 17.2399Z"
                  fill="#667085"
                />
                <g opacity="0.603">
                  <path
                    d="M17.4255 4.85607L17.5447 4.7369L17.4255 4.85607ZM4.45467 17.8269L4.57384 17.7077L4.45467 17.8269ZM10.9997 2.18857V2.11523V2.18857ZM10.9997 20.4486V20.3752V20.4486ZM1.90634 11.2819H1.83301H1.90634ZM20.1663 11.2819H20.093H20.1663ZM4.57384 4.85607L4.45467 4.7369L4.57384 4.85607ZM17.5447 17.8269L17.4255 17.7077L17.5447 17.8269Z"
                    fill="#344054"
                  />
                  <path
                    d="M17.5447 17.8269L17.4255 17.7077M17.4255 4.85607L17.5447 4.7369L17.4255 4.85607ZM4.45467 17.8269L4.57384 17.7077L4.45467 17.8269ZM10.9997 2.18857V2.11523V2.18857ZM10.9997 20.4486V20.3752V20.4486ZM1.90634 11.2819H1.83301H1.90634ZM20.1663 11.2819H20.093H20.1663ZM4.57384 4.85607L4.45467 4.7369L4.57384 4.85607Z"
                    stroke="#344054"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
              <div className="">
                <span className="fs-2 fw-bold">Total Season</span>
                <br />
                <span className="fs-3 fw-semibold ms-4">
                  {seasonData?.data?.count || 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="bg-warning rounded-2 d-flex gap-3 align-items-center p-5">
              <svg
                width="70"
                height="71"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.8226 9.5032H7.17754C6.09587 9.5032 5.72005 8.77903 6.35255 7.89903L10.1751 2.5457C10.6242 1.90404 11.3759 1.90404 11.8159 2.5457L15.6384 7.89903C16.2801 8.77903 15.9042 9.5032 14.8226 9.5032Z"
                  fill="#2D903E"
                  stroke="#2D903E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.1239 16.7818H5.88475C4.43641 16.7818 3.94141 15.8193 4.79391 14.6459L8.4514 9.50342H13.5572L17.2147 14.6459C18.0672 15.8193 17.5722 16.7818 16.1239 16.7818Z"
                  fill="#2D903E"
                  stroke="#2D903E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.6"
                  d="M11 20.4484V16.7817"
                  stroke="#2D903E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div className="">
                <span className="fs-2 fw-bold">Total Crop</span>
                <br />
                <span className="fs-3 fw-semibold ms-4">
                  {cropData?.data?.count || 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="bg-success rounded-2 d-flex gap-3 align-items-center p-5">
              <svg
                width="70"
                height="71"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.6"
                  d="M8.43311 11.0068H13.0164"
                  stroke="#667085"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.6"
                  d="M10.7251 13.2982V8.71484"
                  stroke="#667085"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.5418 19.5319C15.3513 19.5319 19.2502 15.633 19.2502 10.8236C19.2502 6.01409 15.3513 2.11523 10.5418 2.11523C5.73235 2.11523 1.8335 6.01409 1.8335 10.8236C1.8335 15.633 5.73235 19.5319 10.5418 19.5319Z"
                  stroke="#667085"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.6"
                  d="M20.1668 20.4486L18.3335 18.6152"
                  stroke="#667085"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div className="">
                <span className="fs-2 fw-bold">Total Experiment</span>
                <br />
                <span className="fs-3 fw-semibold ms-4">
                  {experimentData?.data?.count || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
